import React, { useEffect, useState } from 'react'

import { shuffle, numberInputValidator } from '../Utils/general'

import { RxEyeClosed, RxEyeOpen } from 'react-icons/rx'
import { AiOutlineNumber, AiOutlineQuestionCircle } from 'react-icons/ai'
import { RiNumber0, RiNumber1, RiNumber2, RiNumber3, RiNumber4, RiNumber5, RiNumber6, RiNumber7, RiNumber8, RiNumber9 } from 'react-icons/ri'
import { BiSend } from 'react-icons/bi'
import { MdOutlineKeyboardBackspace, MdClear, MdOutlineDriveFileRenameOutline, MdOutlineQuestionAnswer } from 'react-icons/md'
import { GiKeyLock, GiDoorRingHandle } from 'react-icons/gi'
import { GrStatusGood } from 'react-icons/gr'


import '../Styles/Register.css'
import '../Styles/Form.css'

import { useStateValue } from '../Utils/StateProvider'
import axios from 'axios'
import { useCookies } from 'react-cookie';
import { Link } from 'react-router-dom'

function Online() {
    const [{ url }, payload] = useStateValue()
    const [error, setError] = useState({
        status: false
    })
    const [enroller, setEnroller] = useState({})
    const [activeStage, setActiveStage] = useState(1)
    const [viewPass, setViewPass] = useState(false)
    const [viewCPass, setViewCPass] = useState(false)
    const [input, setInput] = useState('')
    const [ct, setCT] = useState(null)
    const [questions, setQuestions] = useState([
        `In what city were you born?`,
        `What is the name of your favorite pet?`,
        `What is your mother's maiden name?`,
        `What high school did you attend?`,
        `What was the name of your elementary school?`,
        `What was the make of your first car?`,
        `What was your favorite food as a child?`
    ])
    const [cookies, setCookie, removeCookie] = useCookies(['bearerToken']);
    const [enrollData, setEnrollData] = useState({
        q1: questions[0],
        q2: questions[1],
        q3: questions[2]
    })

    const form_row_count = 4
    let buttons = [
        <RiNumber0 data-number={0} onClick={e => setInput(`${input}0`)} />,
        <RiNumber1 data-number={1} onClick={e => setInput(`${input}1`)} />,
        <RiNumber2 data-number={2} onClick={e => setInput(`${input}2`)} />,
        <RiNumber3 data-number={3} onClick={e => setInput(`${input}3`)} />,
        <RiNumber4 data-number={4} onClick={e => setInput(`${input}4`)} />,
        <RiNumber5 data-number={5} onClick={e => setInput(`${input}5`)} />,
        <RiNumber6 data-number={6} onClick={e => setInput(`${input}6`)} />,
        <RiNumber7 data-number={7} onClick={e => setInput(`${input}7`)} />,
        <RiNumber8 data-number={8} onClick={e => setInput(`${input}8`)} />,
        <RiNumber9 data-number={9} onClick={e => setInput(`${input}9`)} />

    ]

    buttons = shuffle(buttons)

    const QuestionComponent = ({identifier, pos, id = 0}) => {
        const _first_question = questions[id]
        const _questions = questions.filter(question => question !== _first_question)

        const setValue = (name, value) => {
            let newObject = enrollData
            newObject[name] = value

            setEnrollData(newObject)
        }
        return (
            <div className="input-row select-input questions">
                <select 
                    name={identifier} 
                    id={identifier} 
                    value={enrollData[identifier] || ''} 
                    onChange={e => setValue(identifier, e.target.value)} 
                    required
                >
                    <option value={_first_question.toLowerCase()}>{_first_question}</option>
                {
                    _questions?.map((question, index) => (
                        <option key={index} value={question}>{question}</option>
                    ))
                }
                </select>
                <label htmlFor={identifier}>Question {pos} <span style={{color: 'red'}}>*</span></label>
                <AiOutlineQuestionCircle /> 
            </div>
        )
    }

    const goBackward = () => setActiveStage(activeStage - 1)

    const goForward = async () => {
        setError({status: false})
        switch(activeStage) {
            case 1:
                if (!enrollData.account || enrollData.account.length < 12) return setError({
                    status: true,
                    message: 'A valid account number required.'
                })
                try {
                    const request = await axios.get(`${url}/api/u?account=${enrollData.account}`, {
                        headers: { Authorization: `Bearer ${cookies.bearerToken}` }, 
                        onDownloadProgress: ProgressEvent => { console.log(ProgressEvent) }
                    })
                    setEnroller(request.data.data)
                    setActiveStage(2)                        
                }catch (err) {
                    console.error(err.response.data.message)
                    setError({
                        status: true,
                        message: err.response.data.message
                    })
                }                 
                break;
            case 2:
                if (!enrollData.username) return setError({
                    status: true,
                    message: 'User ID required.'
                })
                if (enrollData.username.length < 6 || enrollData.username.length > 20) return setError({
                    status: true,
                    message: 'Invalid User ID.'
                })
                if (!enrollData.secure_pin) return setError({
                    status: true,
                    message: 'Security PIN required.'
                })
                if (enrollData.secure_pin.length !== 8) return setError({
                    status: true,
                    message: 'Invalid Security PIN.'
                })
                if (!enrollData.password) return setError({
                    status: true,
                    message: 'Password required.'
                })
                if (enrollData.password.length < 8) return setError({
                    status: true,
                    message: 'Invalid Password.'
                })
                if (enrollData.cpassword !== enrollData.password) return setError({
                    status: true,
                    message: 'Passwords do not match.'
                })

                setActiveStage(3)
                break;
            case 3:
                if (
                    !enrollData.a1 ||
                    !enrollData.a2 ||
                    !enrollData.a3
                ) return setError({
                    status: true,
                    message: 'Missing required answer.'
                })
                if (
                    enrollData.a1.length < 3 ||
                    enrollData.a2.length < 3 ||
                    enrollData.a3.length < 3
                ) return setError({
                    status: true,
                    message: 'Invalid provided answer. must be above 3 characters.'
                })


                payload({type: 'TOGGLE_PROCESSING', state: true})
                // send OTP for validation
                try {
                    const request = await axios.get(`${url}/api/m/otp?uid=${enroller.uid}`, {
                        headers: {
                            Authorization: `Bearer ${cookies.bearerToken}`
                        }
                    })
                    setCT(request.data.data)
                    setActiveStage(4)
                }catch (err) {
                    setError({
                        status: true,
                        message: err.response.data.message
                    })
                }finally {
                    payload({type: 'TOGGLE_PROCESSING', state: false})
                }

                break;
            case 4:
                if (input === '') return setError({
                    status: true,
                    message: 'OTP required.'
                })

                if (input.length !== 8) return setError({
                    status: true,
                    message: 'Invalid OTP provided.'
                })

                payload({
                    type: 'TOGGLE_PROCESSING',
                    state: true
                })
                try {
                    await axios.post(`${url}/api/m/otp`, {
                        token: `Bearer ${ct}`,
                        otp: input
                    }, {
                        headers: {
                            Authorization: `Bearer ${cookies.bearerToken}`
                        }
                    })

                    // submit enroll form
                    const {cpassword, ...newData} = enrollData
                    newData.uid = enroller.uid

                    await axios.post(`${url}/api/u/online-enroll`, newData, {
                        headers: {
                            Authorization: `Bearer ${cookies.bearerToken}`
                        }
                    })

                    setActiveStage(5)
                    removeCookie('bearerToken')
                }catch (err) {
                    setError({
                        status: true,
                        message: err.response.data.message
                    })
                }finally {
                    payload({
                        type: 'TOGGLE_PROCESSING',
                        state: false
                    })
                }

                break;
        }
    }

    const checkUserID = async (e) => {
        let u = e.target.value
        try {
            await axios.get(`${url}/api/u/validate?username=${u}`, {
                headers: { Authorization: `Bearer ${cookies.bearerToken}` }
            })
            setError({
                status: true,
                message: 'User ID already exists.'
            })
            setEnrollData({...enrollData, username: ''})
        }catch (err) {} 

    }

    const setBearer = async (source) => {
        try {
            const getToken = await axios.get(`${url}/api/m?local=true`, { cancelToken: source.token })
            setCookie('bearerToken', getToken.data.token, { path: '/', expires: new Date(new Date().getTime() + (1000 * 60 * 60) ) })
        }catch (err) {
            console.error(err.message)
        }
    }

    const handleEnrollment = async (e) => {
        e.preventDefault()
        console.log(e.target.elements)
    }

    useEffect(() => {
        const source = axios.CancelToken.source()
        if (!cookies.bearerToken || [undefined, 'undefined', null, 'null'].includes(cookies.bearerToken)) setBearer(source)
        return () => {
            source.cancel()
        }
    }, [])

    return (
        <main className="enroll">
            <div className="container">
                <div className="row">
                    <div className="desc">
                        <h1>Online Banking Enrollment</h1>
                    </div>
                </div>
                <div className="row">
                    <form onSubmit={handleEnrollment}  className='default'>
                        {
                            error.status && (
                                <div className="error-box">{error.message}</div>
                            )
                        }
                        <div className={activeStage === 1 ? "form-pt-one personal-data" : "hide"}>
                            <h1>Identification</h1>
                            <div className="form-row input-row">
                                <input 
                                    type="text" 
                                    name='account' 
                                    id='account' 
                                    value={enrollData.account || ''} 
                                    onChange={e => setEnrollData({ ...enrollData, account: e.target.value })} 
                                    required 
                                />
                                <label htmlFor="account">Account Number <span style={{color: 'red'}}>*</span></label>
                                <AiOutlineNumber />
                                <p className='instructor'>(* 12 digits number)</p>
                            </div>
                        </div>
                        <div className={activeStage === 2 ? "form-pt-two personal-data" : "hide"}>
                            <h1>Authentication Credentials</h1>
                            <div className="form-row input-row">
                                <input 
                                    type="text" 
                                    name='username' 
                                    id='username' 
                                    minLength={6} 
                                    maxLength={20}  
                                    value={enrollData.username || ''} 
                                    onChange={e => setEnrollData({ ...enrollData, username: e.target.value })}
                                    onBlur={checkUserID}
                                    required 
                                />
                                <label htmlFor="username">User ID <span style={{color: 'red'}}>*</span></label>
                                <AiOutlineNumber />
                                <p className='instructor'>(* 6-20 alphanumeric ID)</p>
                            </div>
                            <div className="form-row input-row">
                                <input 
                                    type="text" 
                                    name='secure_pin' 
                                    id='secure_pin' 
                                    minLength={8} 
                                    maxLength={8} 
                                    value={enrollData.secure_pin || ''} 
                                    onChange={e => setEnrollData({ ...enrollData, secure_pin: e.target.value })} 
                                    onKeyUp={e => numberInputValidator(e.target.value, 'secure_pin', enrollData, (data) => setEnrollData(data))} 
                                    required 
                                />
                                <label htmlFor="secure_pin">Security PIN (8 digits PIN)</label>
                                <AiOutlineNumber />
                                <p className='instructor'>(* 8 digits pin)</p>
                            </div>
                            <div className="form-row input-row password-row">
                                <input 
                                    type={viewPass ? "text" : "password"} 
                                    name='password' 
                                    id='password' 
                                    minLength={8} 
                                    onChange={e => setEnrollData({ ...enrollData, password: e.target.value })} 
                                    required 
                                />
                                <label htmlFor="password">New Passphrase <span style={{color: 'red'}}>*</span></label>
                                {
                                    viewPass ? (
                                        <RxEyeOpen onClick={() => setViewPass(false)} />
                                    ) : (
                                        <RxEyeClosed onClick={() => setViewPass(true)} />
                                    )
                                }
                                <p className='instructor'>(* 8 characters min)</p>
                            </div>
                            <div className="form-row input-row password-row">
                                <input 
                                    type={viewCPass ? "text" : "password"} 
                                    name='cpassword' 
                                    id='cpassword' 
                                    onChange={e => setEnrollData({ ...enrollData, cpassword: e.target.value })} 
                                    required 
                                />
                                <label htmlFor="cpassword">Confirm Passphrase <span style={{color: 'red'}}>*</span></label>
                                {
                                    viewCPass ? (
                                        <RxEyeOpen onClick={() => setViewCPass(false)} />
                                    ) : (
                                        <RxEyeClosed onClick={() => setViewCPass(true)} />
                                    )
                                }
                            </div>
                        </div>
                        <div className={activeStage === 3 ? "form-pt-three personal-data" : "hide"}>
                            <h1>Security Questions</h1>
                            <div className="form-row split-row">
                                {<QuestionComponent identifier='q1' id={0} pos={'One'} />}                     
                                <div className="input-row">
                                    <input 
                                        type="text" 
                                        name='a1' 
                                        id='a1' 
                                        value={enrollData.a1 || ''} 
                                        onChange={e => setEnrollData({...enrollData, a1: e.target.value})} 
                                        required 
                                    />
                                    <label htmlFor="a1">Answer <span style={{color: 'red'}}>*</span></label>
                                    <MdOutlineQuestionAnswer />
                                </div>
                            </div>
                            <div className="form-row split-row">
                                {<QuestionComponent identifier='q2' id={1} pos={'Two'} />}                     
                                <div className="input-row">
                                    <input 
                                        type="text" 
                                        name='a2' 
                                        id='a2' 
                                        value={enrollData.a2 || ''} 
                                        onChange={e => setEnrollData({...enrollData, a2: e.target.value})} 
                                        required 
                                    />
                                    <label htmlFor="a2">Answer <span style={{color: 'red'}}>*</span></label>
                                    <MdOutlineQuestionAnswer />
                                </div>
                            </div>
                            <div className="form-row split-row">
                                {<QuestionComponent identifier='q3' id={2} pos={'Three'} />}                     
                                <div className="input-row">
                                    <input 
                                        type="text" 
                                        name='a3' 
                                        id='a3' 
                                        value={enrollData.a3 || ''} 
                                        onChange={e => setEnrollData({...enrollData, a3: e.target.value})} 
                                        required 
                                    />
                                    <label htmlFor="a3">Answer <span style={{color: 'red'}}>*</span></label>
                                    <MdOutlineQuestionAnswer />
                                </div>
                            </div>
                        </div>
                        <div className={activeStage === 4 ? "form-pt-four personal-data" : "hide"}>
                            <h1>PassCode</h1>
                            <p><span style={{fontStyle: 'italic', fontWeight: 700, color: '#fff', fontSize: '12px', marginRight: 10, backgroundColor: 'red', padding: 5}}>NB</span>A One Time Password (OTP) code has been sent to the email address linked to this account. Please confirm below to proceed.</p>
                            <div className="form-row input-row not-required">
                                <input type="text" name='otp' id='otp' defaultValue={input} readOnly />
                                <label htmlFor="otp">One Time Pass Code</label>
                                <GiKeyLock />
                            </div>
                            <div className="form-row digit-btns">
                                <div className="buttons">
                                    {
                                        buttons.map((button, index) => <div key={index} className='button'>{button}</div>)
                                    }
                                </div>
                                <div className="controls">
                                    <div className="control"><MdOutlineKeyboardBackspace onClick={() => setInput(input.slice(0, input.length - 1))} /></div>
                                    <div className="control"><MdClear onClick={() => setInput('')} /></div>
                                    <div className="control"><BiSend onClick={goForward} /></div>
                                </div>
                            </div>
                        </div>
                        <div className={activeStage === 5 ? "form-pt-four personal-data" : "hide"}>
                            <div className="response-screen success">
                                <GrStatusGood />
                                <p>
                                    You have successfully enrolled for an online banking access for your {enroller.account_type || 'Checking Account'}.
                                    Welcome to the team. Log onto your account's online dashboard through the <Link to='/'>account authentication panel</Link>
                                </p>
                            </div>
                        </div>
                        <div className="btn-row split-row">
                            <div className="left-column">
                                {
                                    activeStage > 1 && activeStage < form_row_count && (
                                        <button type='button' onClick={goBackward}>Back</button>
                                    )
                                }
                            </div>
                            <div className="right-column">
                                {
                                    activeStage < form_row_count && (
                                        <button type='button' onClick={goForward}>{activeStage === 1 ? 'Validate' : activeStage === 2 ? 'Next' : 'Verify'}</button>
                                    )
                                }
                            </div>
                        </div>
                        {
                            activeStage === form_row_count && (
                                <div className="btn-row split-row">
                                    <button type='button' onClick={goBackward}>Validate</button>
                                    <strong onClick={() => setActiveStage(1)}>cancel</strong>
                                </div>
                            )
                        }
                    </form>
                </div>
            </div>
        </main>
    )
}

export default Online
